<template>
  <div class="item" @click="itemClick">
    <p class="manage_title" :class="{'line': activeStyle}"><slot></slot></p>
  </div>
</template>

<script>
export default {
  name: "Item",
  props: {
    path: String,
    activeColor: {
      type: String,
      default: 'var(--themeColorsTint)'
    },
  },
  computed: {
    isActive() {
      return this.$route.path.indexOf(this.path) !== -1
    },
    activeStyle() {
      return this.isActive ? true : false
    }
  },
  methods: {
    itemClick() {
      this.$router.replace(this.path).catch(err => err)
    }
  }
}
</script>

<style scoped>
.item {
  display: inline-block;
}
.line {
  border-bottom: 3px solid var(--themeColors);
  color: var(--themeColors);
}
.manage_title {
  display: inline-block;
  font-size: 14px;
  line-height: 47px;
  margin-left: 15px;
  margin-right: 10px;
  cursor: pointer;
}
</style>